import { render } from "./AutoLink.vue?vue&type=template&id=4bb21b4c"
import script from "./AutoLink.vue?vue&type=script&lang=js"
export * from "./AutoLink.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__